<div class="sidebar-layout">
  <div class="mb-3">
    <ebw-monorepo-sidebar-header
      [icon]="'stacks'"
      [title]="'map.sidebar.dynamic_layers.add_layer_service'"
      [isSvg]="false"
      [isOutline]="true"
      [fill]="true"
    >
      {{ 'map.sidebar.dynamic_layers.info_section_layer_service' | translate }}
    </ebw-monorepo-sidebar-header>

    <button mat-flat-button (click)="addNewLayers()" color="primary" class="w-100 add-layer-btn mb-2">
      <mat-icon>add</mat-icon>
      <span>Aggiungi livello</span>
    </button>
  </div>

  <div class="sidebar-layout-body">
    <div *ngIf="layersList.length === 0" class="d-flex justify-content-center">
      <h4>
        {{ 'common.no_result' | translate }}
      </h4>
    </div>
    <div class="list-wrapper" *ngIf="layersList.length > 0">
      <mat-list>
        <mat-list-item *ngFor="let layer of layersList">
          <div class="list-item-grid" matLine>
            <!-- visibility toggle button -->
            <mat-slide-toggle
              [matTooltip]="'map.sidebar.dynamic_layers.on_off' | translate"
              [(ngModel)]="layer.visible"
              (ngModelChange)="setVisibility(layer)"
            ></mat-slide-toggle>
            <!-- layer title -->
            <div class="overflow-hidden list-item-grid--label" [matTooltip]="getTooltip(layer.id)">
              <span>{{ layer.label | uuid | normalize }}</span>
            </div>
            <!-- action buttons -->
            <div>
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item class="w-100" (click)="removeLayers(layer)" *ngIf="checkIfCanDelete(layer)">
                  <mat-icon class="me-1" color="warn">delete</mat-icon>
                  <span>{{ 'common.delete' | translate }}</span>
                </button>

                <ebw-monorepo-opacity-slider [layerId]="layer.id" [icon]="true"></ebw-monorepo-opacity-slider>
              </mat-menu>
            </div>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
  </div>
</div>
